module.exports = __webpack_public_path__ + "static/media/arrow_up.1b25b31e.svg";